import { render, staticRenderFns } from "./modalAddAutomatedNotificationSetup.vue?vue&type=template&id=78ea5c73&"
import script from "./modalAddAutomatedNotificationSetup.vue?vue&type=script&lang=js&"
export * from "./modalAddAutomatedNotificationSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports